import React from "react";
import SEO from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Section } from "@/components/Primitives";
import AssessmentForm from "@/components/AssessmentForm";

export default function Eligibility() {
  return (
    <>
      <SEO title="Check Your Eligibility" description="Complete a short, confidential business assessment with Global Pass Consultants. Contact us to know more." path="/eligibility" />
      <PageHero eyebrow="Confidential Assessment" title="Check Your Eligibility"
        subtitle="A short, professional assessment of your business, preferred country and goals. This does not create a professional-client relationship and no outcome is guaranteed." />
      <Section className="bg-white" pattern>
        <div className="max-w-3xl mx-auto rounded-3xl border border-slate-100 shadow-xl p-6 md:p-10 bg-white">
          <AssessmentForm />
        </div>
      </Section>
    </>
  );
}
